exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".assign-trip-model[data-v-57fef0da] {\n  max-width: 350px;\n}\n", ""]);

// exports
